import React from 'react';
import { FormControl, FormControlLabel } from '@mui/material';

import { CustomRadioGroupProps } from './types';
import { HorizontalRadioGroup, StyledErrorText, StyledRadio } from './styles';

const CustomRadioGroup: React.FC<CustomRadioGroupProps> = ({
  options,
  value,
  onChange,
  name,
  disabled = false,
  error = false,
  errorMessage,
}) => {
  return (
    <FormControl error={error} disabled={disabled} component="fieldset">
      <HorizontalRadioGroup
        name={name}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<StyledRadio />}
            label={option.label}
          />
        ))}
      </HorizontalRadioGroup>
      {error && errorMessage && (
        <StyledErrorText>{errorMessage}</StyledErrorText>
      )}
    </FormControl>
  );
};

export default CustomRadioGroup;
